angular.module('unergie.main')
.filter('invoiceStatusFr', () => {
    const filter = function (value) {
        switch (value) {
            case 0: return 'Initiale'
            case 11: return 'Valorisée'
            case 12: return 'Valorisée à vérifier'
            case 10: return 'En traitement'
            case 20: return 'Warning conso'
            case 21: return 'Erreur conso'
            case 40: return 'Préparée'
            case 49: return 'Préparée en attente'
            case 501: return 'Simulation Ok'
            case 502: return 'Simulation à vérifier'
            case 50: return 'Ok'
            case 54: return 'Partielle'
            case 55: return 'Ok'
            case 59: return 'Ok en attente'
            case 70: return 'Annulée'
            case 75: return 'Reversée'
            case 90: return 'Erreur'
            case 91: return 'Erreur valorisation'
            case 92: return 'Erreur préparation'
            case 93: return 'Erreur PDF'
            case 96: return 'Erreur envoi'
            case 99: return 'Erreur simulation'
            default: return value
        }
    }

    return filter
})
